import { FC } from "react";
import S from "./mainboard.styled";
import { progressWithCountProps } from "../../utils/types/progress-bar";

const ProgressWithCount: FC<progressWithCountProps> = ({ children }) => {
  return <S.ProgressWithCountWrapper>{children}</S.ProgressWithCountWrapper>;
};

export default ProgressWithCount;
